const entity = 'handlers'
const entitySingle = 'handler'
const tableIcon = 'cil-user'

export {
  entity,
  entitySingle,
  tableIcon
}
